// Application configuration

const appConfig = {
  appName: process.env.VUE_APP_TITLE || 'CACFP FOOD PROGRAM',
  apiUrl: process.env.VUE_APP_API_URL || '/api'
}

export default {
  install: (app) => {
    // Add global properties
    app.config.globalProperties.$appName = appConfig.appName
    app.config.globalProperties.$apiUrl = appConfig.apiUrl
  }
}
